"use client";

import { useIsomorphicLayoutEffect } from "@/hooks/useIsomorphicLayoutEffect";
import { useRouter } from "@/i18n/routing";
import { useAuth } from "@/lib/centra/hooks/useAuth";
import React from "react";

type Props = {
  children: React.ReactNode;
  fallback?: React.ReactNode;
};

/**
 * Only renders children if user is logged in
 */
const AccountGuard = ({ children, fallback }: Props) => {
  const { isLoggedIn, isLoading } = useAuth();
  const router = useRouter();

  useIsomorphicLayoutEffect(() => {
    if (!isLoading && !isLoggedIn) {
      router.replace(`/login?redirect=${encodeURIComponent("/")}`);
    }
  }, [isLoading, isLoggedIn, router]);

  if (isLoading || !isLoggedIn) return fallback || null;

  return <>{children}</>;
};

export default AccountGuard;
